<h2 class="sr-only">{{ "ErweiterteSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="gsErweitert" #form="ngForm">
  <cap-form-row>
    <cap-form-control column-classes="col-md-2,col-md-4" labelKey="Gemeinde">
      <cap-gb-gemeinde
        (ngModelChange)="gsErweitert && (gsErweitert.gbGemeindeId = $event)"
        [hasfocus]="true"
        [ngModel]="gsErweitert && gsErweitert.gbGemeindeId"
        [nurGueltige]="false"
        [searchMode]="gbGemeindeSearchMode"
        class="typeahead-holder"
        name="gbGemeindeId">
      </cap-gb-gemeinde>
    </cap-form-control>
  </cap-form-row>
  <cap-form-row column-classes="col-md-2,col-md-4">
    <cap-form-control column-classes="col-md-2,col-md-4" labelKey="Ortschaft">
      <cap-ortschaft-selection
        (ngModelChange)="gsErweitert && (gsErweitert.ortschaftVersionId = $event)"
        [ngModel]="gsErweitert && gsErweitert.ortschaftVersionId"
        class="typeahead-holder"
        name="ortschaftVersionId">
      </cap-ortschaft-selection>
    </cap-form-control>
  </cap-form-row>
  <cap-form-row>
    <cap-form-control
      column-classes="col-md-2,input-series col col-md-3"
      invalidKey="EingabeMussGueltigeStrasseSein"
      labelKey="StrasseOderFlurnameHausnummer">
      <input
        (ngModelChange)="gsErweitert && gsErweitert.adresseSearchRequest && (gsErweitert.adresseSearchRequest.strasseOderFlurname = $event)"
        [ngModel]="gsErweitert && gsErweitert.adresseSearchRequest && gsErweitert.adresseSearchRequest.strasseOderFlurname"
        name="adresseSearchRequestStrasseOderFlurname"
        size="20"
        type="text" />
    </cap-form-control>
    <cap-form-control column-classes="col-md-2, input-series col col-md-1 col-sm-2">
      <input
        (ngModelChange)="gsErweitert && gsErweitert.adresseSearchRequest && (gsErweitert.adresseSearchRequest.nummer = $event)"
        [ngModel]="gsErweitert && gsErweitert.adresseSearchRequest && gsErweitert.adresseSearchRequest.nummer"
        name="adresseSearchRequestNummer"
        size="6"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <div class="row">
    <div class="col-4">
      <cap-grundstuecktype-selection
        (ngModelChange)="gsErweitert && (gsErweitert.grundstueckTypAuswahl = $event)"
        [folioSucheMoeglich]="false"
        [mitSucheMoeglich]="false"
        [ngModel]="gsErweitert && gsErweitert.grundstueckTypAuswahl"
        [stwSucheMoeglich]="false"
        name="grundstuecktypeSelection"></cap-grundstuecktype-selection>
    </div>
  </div>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
